import { storage } from '~/stores/LocalStorage';

export interface PendingRefresh {
  jti: string | null;
  startedAt: string;
}

export interface RefreshRotation {
  fromJti: string | null;
  toJti: string | null;
  at: string;
}

interface RefreshJournalState {
  pending: PendingRefresh | null;
  lastRotation: RefreshRotation | null;
}

const STORAGE_KEY = 'auth:refreshJournal';

const EMPTY_STATE: RefreshJournalState = { pending: null, lastRotation: null };

const read = (): RefreshJournalState => {
  try {
    const raw = storage.getItem(STORAGE_KEY);
    return raw ? { ...EMPTY_STATE, ...JSON.parse(raw) } : EMPTY_STATE;
  } catch {
    return EMPTY_STATE;
  }
};

const write = (state: RefreshJournalState): void => {
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    return;
  }
};

export const refreshJournal = {
  begin(jti: string | null): PendingRefresh | null {
    const state = read();
    write({
      ...state,
      pending: { jti, startedAt: new Date().toISOString() },
    });

    return state.pending;
  },

  settle(): void {
    write({ ...read(), pending: null });
  },

  rotated(fromJti: string | null, toJti: string | null): void {
    write({
      pending: null,
      lastRotation: { fromJti, toJti, at: new Date().toISOString() },
    });
  },

  lastRotation(): RefreshRotation | null {
    return read().lastRotation;
  },

  clear(): void {
    try {
      storage.removeItem(STORAGE_KEY);
    } catch {
      return;
    }
  },
};
